<template>
    <v-footer
            style="padding-bottom:20px;"
    >


                <v-row style="">
                    <v-col cols="4" class="pa-0" align="center">
                        <v-list
                                style="max-width:200px;background: transparent;"
                                dense
                                max-height="100"

                        >
                            <v-list-item style="height:30px;min-height: 20px;text-align: center;">
                                <v-list-item-subtitle>Om Oss</v-list-item-subtitle>
                            </v-list-item>
                            <v-list-item  >
                                <v-btn @click="goTo('/about')" small class="mx-auto text-lowercase" style="" text>kontakt</v-btn>
                            </v-list-item>
                            <v-list-item   style="height:30px;min-height: 20px;text-align: center;" >
                                <v-btn @click="goTo('/about?k=ek')" small class="mx-auto text-lowercase" style="" text>tjänsten</v-btn>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col cols="4" class="pa-0" align="center">
                        <v-row>
                            <v-col>
                            <v-img
                                    style="top:10px;cursor: pointer;"
                                    @click="goHome"

                                    :src="require('../assets/logo_black.png')"
                                    :height="24"
                                    :width="80"
                                    contain

                            ></v-img>
                            </v-col>
                        </v-row>
                        <v-row align="center">
                            <v-col>
                                <v-btn href="https://www.facebook.com/hihatstudios/" small text><v-icon left>mdi-facebook</v-icon>{{$vuetify.breakpoint.mdAndUp?'Facebook':''}} </v-btn>

                                <v-btn href="https://discord.com/invite/W6PHc2h" small text>{{$vuetify.breakpoint.mdAndUp?'Discord':''}} <v-icon>mdi-discord</v-icon></v-btn>
                            </v-col>



                        </v-row>




                    </v-col>
                    <v-col cols="4" class="pa-0" align="center">
                        <v-list
                                style="max-width:200px;background: transparent;"
                                dense
                                max-height="100"

                        >
                            <v-list-item style="height:30px;min-height: 20px;text-align: center;">
                                <v-list-item-subtitle>Policy</v-list-item-subtitle>
                            </v-list-item>
                            <v-list-item style="padding-left: 8px;">
                                <v-btn @click="goTo('/policy')" small class="mx-auto text-lowercase" style="" text>sekretesspolicy</v-btn>

                            </v-list-item>
                            <v-list-item  style="height:30px;min-height: 20px;text-align: center;padding-left: 8px;" >
                                <v-btn @click="goTo('/villkor')"  small class="mx-auto text-lowercase" style="" text>användarvillkor</v-btn>
                            </v-list-item>
                        </v-list>
                    </v-col>

                </v-row>

    </v-footer>
</template>

<script>
    export default {
        name: "Footer.vue",
        methods:{
            goHome:function(){
                this.$router.push({ path: '/' })
            },
            goTo:function(location){
                this.$router.push(location,() => {})

            }
        }
    }
</script>

<style scoped>

</style>
